import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import NetworkManager from "../../app/managers/networkManager"
import { config } from "../../app/utils/config"
import { showErrorToast, showSuccessToast } from '../../app/utils/helpers'
import { setIsLoading } from "../../containers/common/commonSlice"
import { store } from "../../app/store/store"

const initialState = {
    managersProfiles: [],
    managersPermissions: {},
    managersList: [],
    teamsManagersList: [],
}

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getManagersProfiles.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.managersProfiles = action.payload.responseData.data
            }
        })
        builder.addCase(getManagersPermissions.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                let profileId = action.meta?.arg?.profileId
                let profileName = action.meta?.arg?.profileName
                let perms = action.payload.responseData.managers_permissions
                if (profileName && perms) {
                    state.managersPermissions = { ...state.managersPermissions, [profileName]: perms[profileName] }
                } else {
                    state.managersPermissions = perms
                }
            }
        })
        builder.addCase(updateManagersPermissions.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast("Autorisations mises à jour avec succès")
            } else {
                showErrorToast("Quelque chose s'est mal passé !")
            }
        })
        builder.addCase(addManagerProfile.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast(action.payload.responseData.message)
            } else if (action.payload.responseData) {
                showErrorToast(action.payload.responseData.message)
            }
        })
        builder.addCase(editManagerProfile.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                showSuccessToast(action.payload.responseData.message)
            } else if (action.payload.responseData) {
                showErrorToast(action.payload.responseData.message)
            }
        })
        builder.addCase(getManagersList.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.managersList = action.payload.responseData.data
            }
        })
        builder.addCase(getTeamsManagersList.fulfilled, (state, action) => {
            if (action.payload.responseData && action.payload.responseData.status) {
                state.teamsManagersList = action.payload.responseData.data
            }
        })
    },
})

export const getManagersProfiles = createAsyncThunk(
    'permissions/getManagersProfiles',
    async (params) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.managersProfiles.getProfiles, params)
            return response
        } catch (error) {
            return error
        }
    }
)

export const addManagerProfile = createAsyncThunk(
    'permissions/addManagerProfile',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.managersProfiles.addProfile, body)
            return response
        } catch (error) {
            return error
        }
    }
)

export const editManagerProfile = createAsyncThunk(
    'permissions/editManagerProfile',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.managersProfiles.editProfile, body)
            return response
        } catch (error) {
            return error
        }
    }
)

export const getManagersPermissions = createAsyncThunk(
    'permissions/getManagersPermissions',
    async (body) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.managersProfiles.getPermissions, body)
            return response
        } catch (error) {
            return error
        }
    }
)

export const updateManagersPermissions = createAsyncThunk(
    'permissions/updateManagersPermissions',
    async (body) => {
        try {
            store.dispatch(setIsLoading(true))
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.managersProfiles.updatePermissions, body)
            store.dispatch(setIsLoading(false))
            return response
        } catch (error) {
            return error
        }
    }
)

export const getTeamsManagersList = createAsyncThunk(
    'permissions/getTeamsManagersList',
    async (params) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.managersProfiles.getTeamsManagersList, params)
            return response
        } catch (error) {
            return error
        }
    }
)

export const getManagersList = createAsyncThunk(
    'permissions/getManagersList',
    async (params) => {
        try {
            let response = await NetworkManager.getInstance().postRequest(config.apiPaths.managersProfiles.getManagersList, params)
            return response
        } catch (error) {
            return error
        }
    }
)

export default permissionsSlice.reducer
